import { createSelector } from 'reselect';
import { educationTypeOrDefaultSelector } from '../ChildrenInfoWorkflowSelector';
import { EXPECTED_TUITION, DURATION } from '../../Summaries/SummaryConstants';
import { OTHER_TUITION } from '../ChildrenInfoWorkflowConstants';
import dictionarySelector from '../../Summaries/SummaryDictionarySelector';

const nextIteratorsSelector = createSelector(
  educationTypeOrDefaultSelector,
  dictionarySelector,
  (educationTypeOrDefault, dictionary) => {
    if (educationTypeOrDefault === OTHER_TUITION) {
      return [EXPECTED_TUITION, DURATION].map(dependencies => dictionary[dependencies].iterator);
    }
    return [];
  },
);

export default nextIteratorsSelector;
